import React from "react";
import EiaCard from "../cards/EiaCard";
import {Flex, Grid, Heading} from "@aws-amplify/ui-react";
import EiaDrawer from "./EiaDrawer";
import D4ItemBaseStatSelect from "../d4/D4ItemBaseStatSelect";
import {contains} from "../../commons/Utils/ArrayUtils";
import {
    canHaveAspects,
    canHaveMythicAffix,
    canHaveSetAffix,
    canHaveUniqueAffix,
    ITEM_NAMES,
    ITEM_RARITIES,
    ITEM_SUB_TYPES,
    ITEM_SUB_TYPES_WITHOUT_STATS,
    ITEM_TYPES,
    ITEM_TYPES_WITH_RARITY,
    MODES,
    PLATFORMS,
    REALM,
    REGIONS
} from "../../commons/enums/D4Enums";
import CurrencySelects from "../CurrencySelects";
import EiaButton from "../EiaButton";
import Utils from "../../commons/Utils/Utils";
import D4ItemSelects from "../d4/D4ItemSelects";
import D4AffixSelects from "../d4/D4AffixSelects";
import EiaTextField from "../EiaTextField";
import {useCookies} from "react-cookie";
import {GAMES} from "../../commons/enums/EiaEnums";

const isSmallScreen = Utils.isSmallScreen();
const searchDrawerColumnSpans = isSmallScreen ? 5 : 1;

const FiltersDrawer = function (props) {

    const {currency, setCurrency, baseItem, setBaseItem, seller, setSeller, baseStats, setBaseStats, affixStats, setAffixStats, setAlert, searchAuctions, isLoading,
        aspects, setAspects, uniqueAffixes, setUniqueAffixes, setAffixes, setSetAffixes, mythicAffixes, setMythicAffixes} = props;

    const [cookies, setCookies, removeCookies] = useCookies(['game', 'mode', 'realm', 'region', 'platform']);
    const cookiesWrapper = {
        game: cookies.game ? cookies.game : GAMES[0],
        mode: cookies.mode ? cookies.mode : MODES[0],
        realm: cookies.realm ? cookies.realm : REALM[0],
        region: cookies.region ? cookies.region : REGIONS[0],
        platform: cookies.platform ? cookies.platform : PLATFORMS[0]
    }

    const itemCanHaveAspects = canHaveAspects(baseItem);
    const itemCanHaveUniqueAffix = canHaveUniqueAffix(baseItem);
    const itemCanHaveSetAffixes = canHaveSetAffix(baseItem);
    const itemCanHaveMythicAffixes = canHaveMythicAffix(baseItem);

    const [openDrawer, setOpenDrawer] = React.useState(false);

    const [updateStatsSelects, setUpdateStatsSelects] = React.useState(false);
    const [updateAspectSelects, setUpdateAspectSelects] = React.useState(false);
    const [updateUniqueAffixSelects, setUpdateUniqueAffixSelects] = React.useState(false);
    const [updateSetAffixesSelects, setUpdateSetAffixesSelects] = React.useState(false);
    const [updateMythicAffixesSelects, setUpdateMythicAffixesSelects] = React.useState(false);

    const updateBaseItem = function(value) {
        setBaseItem(value)
        setUpdateStatsSelects(true)
        setUpdateAspectSelects(true);
        setUpdateUniqueAffixSelects(true);
        setUpdateSetAffixesSelects(true);
        setUpdateMythicAffixesSelects(true);
    }

    const updateSellerUsername = function(value) {
        const temp = Object.assign({}, seller);

        temp.username = value;

        setSeller(temp);
    }

    const resetFilters = function() {
        const itemType = ITEM_TYPES[0];
        const itemSubTypes = ITEM_SUB_TYPES[itemType]
        const itemSubType = itemSubTypes[0];
        const itemNames = ITEM_NAMES[itemSubType];
        const isItemWithRarity = contains(ITEM_TYPES_WITH_RARITY, itemType);

        const initialBaseItem = {};
        initialBaseItem.itemType = itemType;
        initialBaseItem.itemSubType = itemSubType;
        initialBaseItem.name = itemNames[0];
        initialBaseItem.amount = 1;
        initialBaseItem.title = "";
        if(isItemWithRarity) {
            initialBaseItem.rarity = ITEM_RARITIES[0];
        }

        updateBaseItem(initialBaseItem)

        setCurrency({})
        const emptySeller = {}
        emptySeller.username = "";
        setSeller(emptySeller)
        setAspects([])
        setUniqueAffixes([])
        setSetAffixes([])
        setMythicAffixes([])
        setBaseStats([])
        setAffixStats([])
    }

    return(
        <div>
            <EiaDrawer open={openDrawer} setOpen={setOpenDrawer} title={"Filters"}>
                <Grid templateColumns="1fr 1fr 1fr 1fr 1fr">
                    <EiaCard columnSpan={searchDrawerColumnSpans}>
                        <D4ItemSelects showAmount={false} baseItem={baseItem} setBaseItem={updateBaseItem} removeAny={false} titleEditable={true}/>
                    </EiaCard>
                    <EiaCard columnSpan={searchDrawerColumnSpans}>
                        <Heading level={5}>Basic Stats</Heading>
                        <D4ItemBaseStatSelect baseItem={baseItem} baseStats={baseStats} setBaseStats={setBaseStats} searchDefaults={true}/>
                    </EiaCard>
                    {
                        contains(ITEM_SUB_TYPES_WITHOUT_STATS, baseItem.itemSubType) ? null :
                            <EiaCard columnSpan={searchDrawerColumnSpans}>
                                <D4AffixSelects
                                    setAlert={setAlert}
                                    size={4}
                                    affixStats={affixStats} setAffixStats={setAffixStats}
                                    updateStatsSelects={updateStatsSelects}

                                    aspects={aspects} setAspects={setAspects}
                                    updateAspectSelects={updateAspectSelects}
                                    itemCanHaveAspects={itemCanHaveAspects}

                                    uniqueAffixes={uniqueAffixes} setUniqueAffixes={setUniqueAffixes}
                                    updateUniqueAffixesSelects={updateUniqueAffixSelects}
                                    itemCanHaveUniqueAffixes={itemCanHaveUniqueAffix}

                                    setAffixes={setAffixes} setSetAffixes={setSetAffixes}
                                    updateSetAffixesSelects={updateSetAffixesSelects}
                                    itemCanHaveSetAffixes={itemCanHaveSetAffixes}

                                    mythicAffixes={mythicAffixes} setMythicAffixes={setMythicAffixes}
                                    updateMythicAffixesSelects={updateMythicAffixesSelects}
                                    itemCanHaveMythicAffixes={itemCanHaveMythicAffixes}
                                />
                            </EiaCard>
                    }
                    <EiaCard columnSpan={searchDrawerColumnSpans}>

                        <Flex direction={"column"}>
                            <Heading level={5}>Currency</Heading>
                            <CurrencySelects currency={currency} setCurrency={setCurrency} addAnyCurrencyType={true} game={cookiesWrapper.game}/>
                            <Heading level={5}>Seller</Heading>
                            <EiaTextField onChange={(e) => updateSellerUsername(e.currentTarget.value)} label="Username" value={seller.username}/>
                            <EiaButton isFullWidth colorTheme={"success"} onClick={() => {
                                setOpenDrawer(false);
                                searchAuctions();
                            }} disabled={isLoading}>Search</EiaButton>
                            <EiaButton isFullWidth onClick={resetFilters}>Reset Filters</EiaButton>
                        </Flex>
                    </EiaCard>
                </Grid>
            </EiaDrawer>
            <EiaButton isFullWidth onClick={() => setOpenDrawer(true)} tooltip={"Configure filters to refine your search"}>Filters ...</EiaButton>
        </div>
    )
}
export default FiltersDrawer;